module.exports = __webpack_public_path__ + "img/createFolder.f0d6cffe.svg";